import { PhotoStandardSettings } from 'apps/studio/components/settings/fields/Photo/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { PhotoAdvancedSettings } from 'apps/studio/components/settings/fields/Photo/advanced'

export const PhotoSettings = [
  FieldSettingsPanel(PhotoStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  PhotoAdvancedSettings,
]
